export var UPDATE_PHOTO_REQUEST = 'UPDATE_PHOTO_REQUEST';
export var UPDATE_PHOTO_SUCCESS = 'UPDATE_PHOTO_SUCCESS';
export var UPDATE_PHOTO_ERROR = 'UPDATE_PHOTO_ERROR';
export var COPY_PHOTO_REQUEST = 'COPY_PHOTO_REQUEST';
export var COPY_PHOTO_SUCCESS = 'COPY_PHOTO_SUCCESS';
export var COPY_PHOTO_ERROR = 'COPY_PHOTO_ERROR';
export var DELETE_PHOTO_REQUEST = 'DELETE_PHOTO_REQUEST';
export var DELETE_PHOTO_SUCCESS = 'DELETE_PHOTO_SUCCESS';
export var DELETE_PHOTO_ERROR = 'DELETE_PHOTO_ERROR';
